var ready = (callback) => {
  if (document.readyState != "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
};

ready(() => {

	tradeshowRedirect();
	
});


function tradeshowRedirect() {
	// console.log(window.location.href);
	if(window.location.href == 'https://wholesale.trehouse.com/?utm_source=qrcode&utm_medium=business+card&utm_campaign=trehouse-wholesale&utm_term=tradeshow&utm_content=wholesale+') {
		window.location.href = 'https://wholesale.trehouse.com/pages/show-contact-form';
	}
}